var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86833 4.80899L4.71886 6.60674C4.88849 6.77154 4.97331 6.96255 4.97331 7.17978C4.97331 7.397 4.89219 7.58801 4.72996 7.75281C4.55293 7.9176 4.35261 8 4.129 8C3.9054 8 3.70878 7.9176 3.53915 7.75281L0.254448 4.5618C0.0848161 4.4024 0 4.21648 0 4.00405C0 3.79161 0.0848161 3.603 0.254448 3.4382L3.53915 0.247191C3.70878 0.082397 3.9054 0 4.129 0C4.35261 0 4.55293 0.082397 4.72996 0.247191C4.89219 0.411985 4.97331 0.602996 4.97331 0.820225C4.97331 1.03745 4.88849 1.22846 4.71886 1.39326L2.86833 3.19101H12.1661C12.4024 3.19101 12.6004 3.26809 12.7604 3.42225C12.9201 3.5764 13 3.76742 13 3.99528C13 4.22315 12.9201 4.41573 12.7604 4.57303C12.6004 4.73034 12.4024 4.80899 12.1661 4.80899H2.86833Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back_arrow.425d2e4a170a5c5b14e8cca32d088f80.svg";
export { ForwardRef as ReactComponent };